const roleOptions = selectedCompany => {
  if (selectedCompany.label === undefined) {
    return [
      {
        value: "SALES_ASSISTANT",
        label: "業務助理"
      },
      {
        value: "SUPERVISOR",
        label: "業務主管"
      },
      {
        value: "ENGINEER",
        label: "工程師"
      },
      // {
      //   value: "CUSTOMER",
      //   label: "一般使用者"
      // },
      {
        value: "CUSTOMER_PURCHASER",
        label: "採購權使用者"
      }
    ]
  }
  return JSON.stringify(selectedCompany.label) === JSON.stringify("GETECH")
    ? [
        {
          value: "SALES_ASSISTANT",
          label: "業務助理"
        },
        {
          value: "SUPERVISOR",
          label: "業務主管"
        },
        {
          value: "ENGINEER",
          label: "工程師"
        }
      ]
    : [
        {
          value: "CUSTOMER",
          label: "一般使用者"
        },
        {
          value: "CUSTOMER_PURCHASER",
          label: "採購權使用者"
        }
      ]
}

export default roleOptions
